<template>
    <div class="order-success">
        <img class="logo" src="@assets/images/skiLogo.png" mode="widthFix" />
        <div class="logo-name">
            <span class="logo-font">All</span>
            <span class="logo-font eat">Eat</span>
        </div>
        <div class="logo-tips" >Sorry</div>
        <div class="order-desc" >Your payment was failed.</div>
        <div class="order-info" >
            <!-- Reference 
            <span style="margin-left: 5px;" class="order-no" >#{{ orderId }}</span> -->
        </div>
        <div class="btn" @click="gotoPay" >Back to check out</div>
    </div>
  </template>
  
  <script>
  import { postGateway } from "@/request";
  import { loadCustomScript } from "@paypal/paypal-js";
  export default {
    name: "OrderSuccess",
    data() {
      return {
        orderId: "",
        orderCode: "",
        isApp: false,
      };
    },
    created() {
        this.orderId = this.$route.query.orderId;
        this.orderCode = this.$route.query.orderCode;
    },
    mounted() {
        this.hideDom();
        this.loadUniappSdk();
        this.uploadError();
    },
    methods: {
        uploadError() {
            try {
                postGateway({
                    url: '/order/redirect/updateOrderPage',
                    method: "POST",
                    data: {
                        orderId: this.orderId,
                        orderPage: "orderFail",
                    }
                }).then(() => {})
                .catch((err) => {
                    console.log("数据上报失败",err);
                });
                
            } catch (e) {
                console.log("数据上报错误处理");
            }
        },
        loadUniappSdk() {
            loadCustomScript({
            url: "https://www.alleatapp.com/maps2/js/js.cdn.aliyun.dcloud.net.cn_dev_uni-app_uni.webview.1.5.2.js"
            }).then(()=>{
                
            })
            .catch(err=>{
                console.log(err,' script laod error.')
                this.$message.warning('Net error.')
            })
        },
        hideDom() {
            if(this.$route.query.device || localStorage.getItem('order-device')) {
                this.isApp = true;
                let header = document.querySelector('.fix-header');
                header.style.display = 'none';
                let footer = document.querySelector('.footer');
                footer.style.display = 'none';
            }
        },
        gotoPay() {

            if(this.isApp && window.uni) {
                window.uni.navigateBack({
                    delta: 1
                })
                return
            }

            let orderId = localStorage.getItem('viva-order');
            if(orderId) {
                this.$router.replace({
                    path: `/vivaWallet`,
                    query: {
                        orderId: orderId,
                        fromFail: 1
                    }
                })
            } else {
                this.goOrderList();
            }
            
        },
        goOrderList() {
            this.$router.push({
                path: `/usercenter?orderId=${this.orderId}&type=orderDone`,
            });
        }
    },
  };
  </script>
  <style lang="scss" scoped>
  $color: #000;
  .order-success {
    padding-top: 40px;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .logo {
        height: 100px;
        width: 100px;
    }
    .logo-name {
        .logo-font {
            font-size: 30px;
            font-weight: bold;
            color: #aa0bc0;
        }

        .eat {
            margin-left: 8px;
            color: #26d07c;
        }
    }
    .logo-tips {
        color: #26d07c;
        font-size: 30px;
        margin-top: 5px;
    }

    .order-desc {
        color: #333;
        font-size: 24px;
        margin-top: 5px;
    }

    .order-info {
        margin-top: 8px;
        font-size: 45px;
        color: #222;

        .order-no {
            color: #000;
        }
    }

    .btn {
        cursor: pointer;
        height: 48px;
        box-sizing: border-box;
        padding: 6px 80px;
        background-color: #aa0bc0;
        color: #fff;
        font-weight: bold;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        border-radius: 24px;
        margin-top: 20px;
        box-shadow: rgba(0, 0, 0, 0.56) 0px 3px 6px, rgba(0, 0, 0, 0.53) 0px 3px 6px;
    }

  }
  
  @media screen and (max-width: 950px) {
    .order-success {
        min-height: 400px;
        display: flex;
        justify-content: center;
        .order-info {
            margin-top: 8px;
            font-size: 40px;
            white-space: nowrap;
            color: #222;

            .order-no {
                color: #000;
            }
        }
    }
  }
  </style>
  